const Header = ({ children }) => {
  return (
    <div
      style={{
        height: 48,
        backgroundColor: "#d32027",
        color: "#fff",
        fontWeight: 700,
        display: "flex",
        alignItems: "center",
        fontSize: "1.1rem",
        justifyContent: "center",
      }}
    >
      {children}
    </div>
  );
};

export default Header;
